import * as Actions from '../../actions/purchaseOrders/types';

const initialState = {
  // get po's
  loading: false,
  purchaseOrders: [], // po list
  createdPurchaseOrder: {}, // newly created

  error: '', // get, create, update po error

  // get po items
  getPoItemsLoading: false,
  getPoItems: [], // single po items
  getPoItemsError: '',

  // search ro's
  searchROsLoading: false,
  searchROsSuccess: '',
  searchROsError: '',

  // get parts and supply by ro
  getPartsAndSupplyByRoLoading: false,
  getPartsAndSupplyByRoSuccess: '',
  getPartsAndSupplyByRoError: '',
};

export const purchaseOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    //  get all po's
    case Actions.GET_PURCHASE_ORDERS_REQUEST:
      return { ...state, loading: true, error: '' };
    case Actions.GET_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        purchaseOrders: action.payload?.data || [],
      };
    case Actions.GET_PURCHASE_ORDERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //  update single po
    case Actions.UPDATE_PURCHASE_ORDER_REQUEST:
      return { ...state, error: '' };
    case Actions.UPDATE_PURCHASE_ORDER_SUCCESS:
      const foundIndex = state.purchaseOrders?.findIndex(
        (f) => f.id === action.payload.data?.id,
      );
      const pos = state.purchaseOrders || [];
      if (foundIndex !== -1) {
        pos[foundIndex] = { ...action.payload.data };
      }

      return {
        ...state,
        purchaseOrders: pos,
      };
    case Actions.UPDATE_PURCHASE_ORDER_FAIL:
      return {
        ...state,

        error: action.payload,
      };

    //  create po
    case Actions.CREATE_PURCHASE_ORDERS_REQUEST:
      return { ...state, error: '' };
    case Actions.CREATE_PURCHASE_ORDERS_SUCCESS:
      const poList = state.purchaseOrders || [];

      if (action.payload?.data?.id) {
        poList.push(action.payload.data);
      }

      return {
        ...state,
        createdPurchaseOrder: action.payload.data,
        purchaseOrders: [...poList],
      };
    case Actions.CREATE_PURCHASE_ORDERS_FAIL:
      return {
        ...state,

        error: action.payload,
      };
    case Actions.CLEAR_CREATED_PURCHASE_STATE:
      return {
        ...state,
        createdPurchaseOrder: {},
      };
    //  get po items
    case Actions.GET_PURCHASE_ORDER_ITEMS_REQUEST:
      return { ...state, getPoItemsLoading: true };
    case Actions.GET_PURCHASE_ORDER_ITEMS_SUCCESS:
      return {
        ...state,
        getPoItemsLoading: false,
        getPoItems: action.payload?.data || [],
      };
    case Actions.GET_PURCHASE_ORDER_ITEMS_FAIL:
      return {
        ...state,
        getPoItemsLoading: false,
        getPoItems: [],
        getPoItemsError: action.payload,
      };
    case Actions.CLEAR_GET_PURCHASE_ORDER_ITEMS_STATES:
      return {
        ...state,
        getPoItemsLoading: false,
        getPoItems: [],
        getPoItemsError: '',
      };

    //  search po's
    case Actions.SEARCH_REPAIR_ORDERS_REQUEST:
      return { ...state, searchROsLoading: true };
    case Actions.SEARCH_REPAIR_ORDERS_SUCCESS:
      return {
        ...state,
        searchROsLoading: false,
        searchROsSuccess: action.payload || '',
      };
    case Actions.SEARCH_REPAIR_ORDERS_FAIL:
      return {
        ...state,
        searchROsLoading: false,
        searchROsError: action.payload,
      };
    case Actions.CLEAR_SEARCH_REPAIR_ORDERS_STATES:
      return {
        ...state,
        searchROsLoading: false,
        searchROsSuccess: '',
        searchROsError: '',
      };

    //  get parts and supply by ro
    case Actions.GET_PARTS_SUPPLY_BY_RO_REQUEST:
      return { ...state, getPartsAndSupplyByRoLoading: true };
    case Actions.GET_PARTS_SUPPLY_BY_RO_SUCCESS:
      return {
        ...state,
        getPartsAndSupplyByRoLoading: false,
        getPartsAndSupplyByRoSuccess: action.payload || '',
      };
    case Actions.GET_PARTS_SUPPLY_BY_RO_FAIL:
      return {
        ...state,
        getPartsAndSupplyByRoLoading: false,
        getPartsAndSupplyByRoError: action.payload,
      };
    case Actions.CLEAR_PARTS_SUPPLY_BY_RO_STATES:
      return {
        ...state,
        getPartsAndSupplyByRoLoading: false,
        getPartsAndSupplyByRoSuccess: '',
        getPartsAndSupplyByRoError: '',
      };

    default:
      return state;
  }
};
